import { Edit02Icon } from '@/components/icons/Edit02Icon';
import { SlideToolbarButton } from '@/modules/slideEditor/SlideToolbar';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

interface EditDisclaimerToolbarButtonProps {
  /**
   * Called before the admin page opens so the hover toolbar can dismiss itself
   * once the user has acted (mirrors the other presentation hover actions).
   */
  onClick?: () => void;
}

/**
 * "Edit disclaimer" button shown on the presentation disclaimer hover regions
 * (the footer disclaimer on every slide and the firm's standalone disclaimer
 * slide). Opens the legal disclaimers admin page in a new tab. Gate rendering
 * on disclaimer edit access at the call site.
 */
export function EditDisclaimerToolbarButton({
  onClick,
}: EditDisclaimerToolbarButtonProps) {
  return (
    <SlideToolbarButton
      variant="transparent"
      startIcon={Edit02Icon}
      onClick={() => {
        onClick?.();
        const path = getCompletePathFromRouteKey(
          ROUTE_KEYS.ADMIN_LEGAL_DISCLAIMERS,
          {}
        );
        window.open(path, '_blank', 'noopener,noreferrer');
      }}
    >
      Edit disclaimer
    </SlideToolbarButton>
  );
}
